import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { OFFER_ANCHOR } from '../data/constants';
export function Hero() {
  return <section className="border-b-4 border-diag bg-white" data-id="element-72" data-mp="9lv0spiridvb">
      <div className="h-1.5 bg-navy" aria-hidden="true" data-id="element-73" data-mp="4lqictyan92g" />
      <div className="mx-auto max-w-[1080px] px-4 pb-6 pt-5 sm:px-6 sm:pb-9 sm:pt-8" data-id="element-74" data-mp="4n1oh0f7oswq">
        <h1 className="mx-auto max-w-[920px] text-center text-[29px] leading-[1.02] text-navy sm:text-[46px] lg:text-[56px]" data-id="element-75" data-mp="128frrovbsnyc">
          The complete visual fault-finding system{' '}
          <span className="text-diag" data-id="element-76" data-mp="sai4p4p7cx7b">for gasoline engine technicians</span>
        </h1>

        <p className="mx-auto mt-3 max-w-[780px] text-center text-[14px] font-medium leading-snug text-steel sm:text-[17px]" data-id="element-77" data-mp="ncq1hej3xont">
          Stop jumping between service manuals, wiring diagrams, scan-tool data and
          scattered references every time a gasoline engine develops a fault. Use
          organized diagnostic references, symptom-based workflows, sensor guides,
          test procedures and troubleshooting tools to identify what to check and
          follow the fault logically.{' '}
          <strong className="font-bold text-navy" data-id="element-78" data-mp="39aupza1hhgvn">
            Diagnose. Test. Find the cause with confidence.
          </strong>
        </p>

        <MockupImage className="mt-4 sm:mt-5" priority data-id="element-79" data-mp="3e7uxlpdzerov" />

        <div className="mt-4 flex flex-col items-center" data-id="element-80" data-mp="30hho3ilfz4xf">
          <CTAButton href={OFFER_ANCHOR} data-id="element-81" data-mp="30fya5yn9d5yt">🔧 YES! I WANT THE COMPLETE SYSTEM</CTAButton>
          <TrustLine items={['GET GASOLINE ENGINE DIAGNOSTIC PRO™ TODAY', '🛡️ 7-Day Money-Back Guarantee', '⚡ COMPLETE 6-IN-1 SYSTEM']} data-id="element-82" data-mp="35a2fyeksf7yb" />
        </div>
      </div>
    </section>;
}